(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ck5jD", function(module, exports) {
const $8f8b79dcf107dca3$var$selectLinkItems = document.querySelectorAll(".i-select-link");
$8f8b79dcf107dca3$var$selectLinkItems.forEach((item)=>{
    const placeholder = item.querySelector(".i-select-link__placeholder");
    placeholder?.addEventListener("click", ()=>{
        const lastLink = item.querySelector(".link:last-child");
        item.classList.toggle("--open");
        item.classList.toggle("--top", item.classList.contains("--open"));
        item.classList.remove("--bottom");
        if (lastLink) {
            const linkRect = lastLink.getBoundingClientRect();
            console.log(window.innerHeight <= linkRect.bottom);
            if (window.innerHeight <= linkRect.bottom) {
                item.classList.remove("--top");
                item.classList.add("--bottom");
            }
        }
    });
});
document.addEventListener("click", (e)=>{
    const target = e.target;
    if (target instanceof HTMLElement && !target.closest(".i-select-link")) $8f8b79dcf107dca3$var$selectLinkItems.forEach((item)=>item.classList.remove("--open"));
});

});

})();
//# sourceMappingURL=select-link-item.8ae0c556.js.map
